"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableItem = exports.TableRow = exports.TableBody = exports.TableHeader = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Loading = _interopRequireDefault(require("../Loading"));

var _Table = require("./Table.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 表格組件
 */
var Table = function Table(_ref) {
  var className = _ref.className,
      margin = _ref.margin,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "default" : _ref$variant,
      children = _ref.children,
      isSticky = _ref.isSticky;
  return /*#__PURE__*/_react.default.createElement(_Table.UiTable, {
    className: className,
    issticky: isSticky,
    mb: margin,
    variant: variant
  }, children);
};

Table.propTypes = {
  className: _propTypes.default.string,
  variant: _propTypes.default.oneOf(["default", "light"]),
  margin: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  children: _propTypes.default.any,
  isSticky: _propTypes.default.bool
};
var _default = Table;
exports.default = _default;

var TableHeader = function TableHeader(_ref2) {
  var className = _ref2.className,
      children = _ref2.children;
  return /*#__PURE__*/_react.default.createElement(_Table.UiTableHeader, {
    className: className
  }, children);
};

exports.TableHeader = TableHeader;
TableHeader.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.any
};

var TableBody = function TableBody(_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      isLoading = _ref3.isLoading;
  return /*#__PURE__*/_react.default.createElement(_Table.UiTableBody, {
    className: className
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_Loading.default, null) : children);
};

exports.TableBody = TableBody;
TableBody.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.any,
  isLoading: _propTypes.default.bool
};

var TableRow = function TableRow(_ref4) {
  var className = _ref4.className,
      children = _ref4.children,
      isSticky = _ref4.isSticky;
  return /*#__PURE__*/_react.default.createElement(_Table.UiTableRow, {
    className: className,
    issticky: isSticky
  }, children);
};

exports.TableRow = TableRow;
TableRow.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.any,
  isSticky: _propTypes.default.bool
};

var TableItem = function TableItem(_ref5) {
  var className = _ref5.className,
      flex = _ref5.flex,
      children = _ref5.children,
      isSticky = _ref5.isSticky;
  return /*#__PURE__*/_react.default.createElement(_Table.UiTableItem, {
    className: className,
    issticky: isSticky,
    flex: flex
  }, children);
};

exports.TableItem = TableItem;
TableItem.propTypes = {
  className: _propTypes.default.string,
  flex: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  children: _propTypes.default.any,
  isSticky: _propTypes.default.bool
};